<template>
  <div class="region-address-fields operational-form-grid__wide">
    <div class="row">
      <b-form-group class="col-md-6" label="Provinsi:" label-for="address-province">
        <b-form-select id="address-province" v-model="form.province_id" :options="provinces" @change="onProvince" />
      </b-form-group>
      <b-form-group class="col-md-6" label="Kota/Kabupaten:" label-for="address-regency">
        <b-form-select id="address-regency" v-model="form.capital_id" :options="regencies" :disabled="!form.province_id" @change="onRegency" />
      </b-form-group>
      <b-form-group class="col-md-6" label="Kecamatan:" label-for="address-district">
        <b-form-select id="address-district" v-model="form.subdistrict_id" :options="districts" :disabled="!form.capital_id" @change="onDistrict" />
      </b-form-group>
      <b-form-group class="col-md-6" label="Desa/Kelurahan:" label-for="address-village">
        <b-form-select id="address-village" v-model="form.village_id" :options="villages" :disabled="!form.subdistrict_id" />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import module from '@/core/modules/CrudModule.js'

export default {
  name: 'RegionAddressFields',
  props: { form: { type: Object, required: true } },
  data() {
    return { provinces: [], regencies: [], districts: [], villages: [], hydratedFor: null }
  },
  watch: {
    form: {
      immediate: true,
      handler() { this.hydrate() }
    }
  },
  methods: {
    optionList(items, placeholder) {
      return [{ value: null, text: placeholder }, ...(items || []).map(item => ({ value: item.id, text: item.label }))]
    },
    async fetchOptions(route, placeholder) {
      const response = await module.setTreeSelect(route)
      return this.optionList(response.state === 'success' ? response.data : [], placeholder)
    },
    async hydrate() {
      this.provinces = await this.fetchOptions('regions', 'Pilih provinsi')
      const key = [this.form.province_id, this.form.capital_id, this.form.subdistrict_id].join('|')
      if (key === this.hydratedFor) return
      this.hydratedFor = key
      if (this.form.province_id) this.regencies = await this.fetchOptions(`region/${this.form.province_id}`, 'Pilih kota/kabupaten')
      if (this.form.capital_id) this.districts = await this.fetchOptions(`regions/subdistrict?code_id=${this.form.capital_id}`, 'Pilih kecamatan')
      if (this.form.subdistrict_id) this.villages = await this.fetchOptions(`regions/village?code_id=${this.form.subdistrict_id}`, 'Pilih desa/kelurahan')
    },
    async onProvince(value) {
      this.form.capital_id = null; this.form.subdistrict_id = null; this.form.village_id = null
      this.districts = []; this.villages = []
      this.regencies = value ? await this.fetchOptions(`region/${value}`, 'Pilih kota/kabupaten') : []
    },
    async onRegency(value) {
      this.form.subdistrict_id = null; this.form.village_id = null; this.villages = []
      this.districts = value ? await this.fetchOptions(`regions/subdistrict?code_id=${value}`, 'Pilih kecamatan') : []
    },
    async onDistrict(value) {
      this.form.village_id = null
      this.villages = value ? await this.fetchOptions(`regions/village?code_id=${value}`, 'Pilih desa/kelurahan') : []
    }
  }
}
</script>
